import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    myData: [],
  },
  getters: {},
  mutations: {
    PUTDATA(state, data) {
      state.myData = data;
    },
  },
  actions: {
    putData(context, data) {
      context.commit("PUTDATA", data);
    },
  },
  modules: {},
});
